import gql from 'graphql-tag';

export default gql`
mutation editFA_History($payload: FA_History_Edit){
  fakturaAssist{
    editFA_History(payload: $payload)
  }
}`;
